export var BaggageDirection;
(function (BaggageDirection) {
    BaggageDirection[BaggageDirection["There"] = 0] = "There";
    BaggageDirection[BaggageDirection["Return"] = 1] = "Return";
    BaggageDirection[BaggageDirection["RoundTrip"] = 2] = "RoundTrip";
})(BaggageDirection || (BaggageDirection = {}));
